import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip,
  CircularProgress,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Atras from "./atras";
import BottomNav from "./BottomNav";
import { auth, db } from "../firebase";
import { collection, addDoc, query, where, orderBy, getDocs, serverTimestamp } from "firebase/firestore";

// Helper compartido: los tres flujos de pago (suscripción, destacar proyecto,
// certificación) llaman a esto apenas se confirma el pago con PayPal.
export const logPayment = async ({ type, amount, description }) => {
  const uid = auth.currentUser?.uid;
  if (!uid) return;
  try {
    await addDoc(collection(db, "payments"), {
      uid,
      type, // "subscription" | "boost" | "certification"
      amount,
      currency: "USD",
      description,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error logging payment:", error);
  }
};

const TYPE_LABELS = {
  subscription: { label: "Suscripción", color: "primary" },
  boost: { label: "Destacar proyecto", color: "warning" },
  certification: { label: "Certificación", color: "success" },
};

const Payments = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPayments = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }
      try {
        const q = query(
          collection(db, "payments"),
          where("uid", "==", user.uid),
          orderBy("timestamp", "desc")
        );
        const snapshot = await getDocs(q);
        setPayments(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (error) {
        console.error("Error fetching payments:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, [navigate]);

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Mis pagos
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 15, mb: 14 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : payments.length === 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 6, color: "text.secondary" }}>
            <ReceiptLongIcon sx={{ fontSize: 48, mb: 1 }} />
            <Typography>Todavía no registrás pagos en Skach.</Typography>
          </Box>
        ) : (
          <List>
            {payments.map((payment) => (
              <ListItem
                key={payment.id}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, mb: 1.5 }}
              >
                <ListItemText
                  primary={payment.description}
                  secondary={
                    payment.timestamp
                      ? payment.timestamp.toDate().toLocaleString()
                      : "Procesando…"
                  }
                />
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.5 }}>
                  <Typography fontWeight={600}>USD$ {payment.amount}</Typography>
                  <Chip
                    size="small"
                    label={TYPE_LABELS[payment.type]?.label || payment.type}
                    color={TYPE_LABELS[payment.type]?.color || "default"}
                  />
                </Box>
              </ListItem>
            ))}
          </List>
        )}
      </Container>
      <BottomNav />
    </Container>
  );
};

export default Payments;
